import { render } from "./ClientsRankingQtdAttendant.vue?vue&type=template&id=be2cbed6&ts=true"
import script from "./ClientsRankingQtdAttendant.vue?vue&type=script&lang=ts"
export * from "./ClientsRankingQtdAttendant.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__